import React from 'react';
import {connect} from 'react-redux';
import _ from 'lodash';

import GlobalFilterPanel, {FILTER_PERIOD_GROUP} from '../filter/GlobalFilterPanel';
import TransmissionStatusVisibilitySelector from './TransmissionStatusVisibilitySelector';
import TransmissionStatusPropertyFilter from './TransmissionStatusPropertyFilter';

import Logger, {LOG_LEVELS} from '../../utils/logger';

const log = new Logger('TRANSMISSION_STATUS_FILTER_PANEL', LOG_LEVELS.DEBUG);

export class TransmissionStatusFilterPanel extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      selection: {
        'invoiceNumber': '',
        'legalEntity': '',
        'showFailed': 'true',
        'showSuccessful': 'true'
      }
    };
    this.onApply = this.onApply.bind(this);
    this.filterSelectionHandler = this.filterSelectionHandler.bind(this);
  }

  onApply(selection) {
    log.debug('onApply: selection: ' + selection);
    const combinedSelection = Object.assign({}, selection, this.state.selection);
    log.debug('onApply(): combinedSelection: ', combinedSelection);
    if(typeof this.props.onApply === 'function') {
      this.props.onApply(combinedSelection);
    }
  }

  filterSelectionHandler(keyValuePairs) {
    log.debug('filterSelectionHandler() Key value pairs: ', keyValuePairs);
    const key = Object.keys(keyValuePairs)[0];
    const values = Object.values(keyValuePairs)[0];
    let selection = Object.assign({}, this.state.selection);
    if (values === '' || values === 'false') {
        delete selection[key];
    } else {
       selection[key] = values;
    }
    this.setState({
      selection: selection
    });
  }

  render() {
    log.debug('render(): ', this.props);
    const selection = this.state.selection || {};
    return (
        <s-box name="filter-panel">
          <GlobalFilterPanel 
            onSearchClick={this.onApply} 
            disableSearch={_.isEmpty(this.props.queryParams)} 
            hideElements={
              {
                'month': true,
                'year': true,
                'countryCode': true,
                'companyId': true,
                returnType: true,
                returnStatus: true
              }
          }
          filterPeriodGroup={FILTER_PERIOD_GROUP.DATE_RANGE}
        >
          <TransmissionStatusVisibilitySelector 
            selectionHandler={this.filterSelectionHandler} 
            showSuccessful={selection.showSuccessful}
            showFailed={selection.showFailed} />

          <TransmissionStatusPropertyFilter 
            legalEntity={selection.legalEntity} 
            invoiceNumber={selection.invoiceNumber} 
            selectionHandler={this.filterSelectionHandler} />
        </GlobalFilterPanel>
        <div className="clear"></div>
      </s-box>
    )
  }

  componentDidMount() {
    if(!_.isEmpty(this.props.filterOption)) {
      this.setState({
        selection: this.props.filterOption
      });
    }
  }
}

function mapStateToProps(state) {
  log.debug('mapStateToProps: ', state);  
  return {
    languages: state.languages
  };
}


export default connect(mapStateToProps)(TransmissionStatusFilterPanel);
